import {CabinetAssignedSpecialistDto, CabinetAssignedSpecialistRs} from "@/types/assignedSpecialist";

//Mapping from CabinetAssignedSpecialistRs to CabinetAssignedSpecialistDto
export function mapToCabinetAssignedSpecialistDto(from: CabinetAssignedSpecialistRs): CabinetAssignedSpecialistDto {
    return {
        name: from.name,
        title: from.title,
        rating: from.rating,
        experience: from.experience,
        sessionTime: from.sessionTime,
        tags: from.tags,
        reviews: from.reviews,
        priceTag: from.priceTag,
        description: from.description,
        avatarUrl: from.avatarUrl,
        url: from.url,
        career: from.career,
        education: from.education,
        price: from.price,
        serviceAgreementUrl: from.serviceAgreementUrl,
        articlesCount: from.articlesCount,
        enabled: from.enabled,
        localesToSpeak: from.localesToSpeak
    }
}
